import * as z from 'zod';

const numLike = z.coerce.number();

/** One courier row of the self-employment report. */
export const selfEmployedRowSchema = z
  .object({
    id: numLike,
    courier_name: z.string().nullish(),
    phone: z.string().nullish(),
    pinfl: z.string().nullish(),
    pass_data: z.string().nullish(),
    self_employment_status_set: z.boolean().nullish(),
    from_self_employment_status: z.boolean().nullish(),
    till_self_employment_status: z.boolean().nullish(),
  })
  .loose();
export type SelfEmployedRow = z.infer<typeof selfEmployedRowSchema>;

/** One OFD (tax service) status check of a courier. */
export const ofdStatusLogSchema = z
  .object({
    id: numLike,
    courier_id: numLike.nullish(),
    pinfl: z.string().nullish(),
    is_self_employed: z.boolean().nullish(),
    ofd_status_code: numLike.nullish(),
    /** Opaque OFD payload — rendered as JSON text, never interpreted. */
    ofd_raw_response: z.unknown().optional(),
    checked_at: z.string().nullish(),
  })
  .loose();
export type OfdStatusLog = z.infer<typeof ofdStatusLogSchema>;

/** `POST …/self-employment-check` result. */
export const selfEmploymentCheckResultSchema = z
  .object({
    self_employment_status_set: z.boolean().nullish(),
  })
  .loose();
export type SelfEmploymentCheckResult = z.infer<typeof selfEmploymentCheckResultSchema>;

/** A parsed report page: the rows plus the page count the pagination needs. */
export interface ReportPage<T> {
  rows: T[];
  pageCount: number;
}
